var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('heading',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('span')]},proxy:true}])},[_c('h2',[_vm._v(_vm._s(_vm.$t("movements")))]),_c('p',[_vm._v(_vm._s(_vm.$t("movements-.sub-heading")))])]),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }